export class PermissionService {
  constructor() {
    this.filterConstructor = window.PERM_constructor;
    this.fact = window.PERM_fact;
    this.is_staff = window.PERM_is_staff;
    this.brand = window.BRAND;
    this.languages = window.LANGUAGES;
    this.languagesCount = Object.keys(this.languages).length;
    this.selectedLang = window.selectedLang;
    this.config = window.PERM_config;
    this.admin = window.PERM_admin;
    this.agentVersion = window.AGENT_VERSION;
    this.host = window.HOST;
    this.userName = window.USER_NAME;
    this.terminalCommands = window.TERMINAL_COMMANDS;
    this.terminalCommandsCount = Object.keys(this.terminalCommands).length;
    this.sessionDb = window.SESSION_DB;
    this.maxAgentsExceeded = window.MAX_AGENTS_EXCEEDED;
    this.userGroups = window.PERM_GROUPS;
    this.groupSystemAdministrator = (~window.PERM_GROUPS.indexOf('System administrator')) ? true : false;
    this.showAdminMenu = window.PERM_is_staff && // Only admin can see 'Admin menu'
                        window.PERM_constructor &&
                        window.PERM_fact &&
                        window.PERM_config &&
                        window.PERM_admin ||
                        this.groupSystemAdministrator;
  }
}



// WEBPACK FOOTER //
// ./src/core/permission.service.js